import React, { useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col
} from "reactstrap";

import BasicModal from '../../../../components/Modals/BasicModal'
import SelectCountry from './SelectCountry';
import {titleCase} from '../../../../utils/views/pages/Dynamics'

const ContactInformation = (props) => {
    const institution = props.institution
    const formDisabled = props.formDisabled
    const setInstitution = props.setInstitution
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const validations = props.validations

    let validateField = (e) => {
        //console.log(!e.target.value.trim() && e.target.required)
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {

        institution[e.target.name] = e.target.value
        setInstitution(institution)

    }

    return (
        <>
            {/* Address */}
            <h6 className="heading-small text-muted mb-4">
                Contact information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-address"
                            >
                                Address
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={institution?.address}
                                id="input-address"
                                name="address"
                                placeholder="Institution Address"
                                type="text"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-city"
                            >
                                City
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={institution?.city}
                                id="input-city"
                                name="city"
                                placeholder="City"
                                type="text"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-country"
                            >
                                Country
                            </label>

                            <SelectCountry
                                country={institution?.country}
                                formDisabled={formDisabled}
                                setInstitution={setInstitution}
                                institution={institution} />

                        </FormGroup>
                    </Col>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-country"
                            >
                                Postal code
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-postal-code"
                                name="postalCode"
                                defaultValue={institution?.postalCode}
                                type="text"
                                disabled={formDisabled}
                                placeholder="Number"
                                onChange={handleInput}
                                required={false}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />

        </>
    )
}

export default ContactInformation;